/* playPauseBlanket-compiled.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import "./playPauseBlanket-compiled.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
var playPauseBlanketStyles = null;
export var PlayPauseBlanket = function PlayPauseBlanket(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: ax(["_1bsb1osq _4t3i1osq _80omtlke"])
  }), children);
};